import { render } from "./BulletinBoardMobile.vue?vue&type=template&id=c51a0f82&scoped=true"
import script from "./BulletinBoardMobile.vue?vue&type=script&lang=js"
export * from "./BulletinBoardMobile.vue?vue&type=script&lang=js"

import "./BulletinBoardMobile.vue?vue&type=style&index=0&id=c51a0f82&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51a0f82"]])

export default __exports__